import {
  IResourceComponentsProps,
  useNotification,
} from "@pankod/refine-core";
import {
  Edit,
  useForm,
} from "@pankod/refine-antd";
import { IHealthInsurer } from "interfaces";
import { HealthInsurerForm } from "components/forms";
import { extractApiErrorMessage } from "utils/utils";

export const HealthInsurerEdit: React.FC<IResourceComponentsProps> = () => {
  const notification = useNotification();
  const { formProps, saveButtonProps, queryResult } = useForm<IHealthInsurer>({
    errorNotification: false,
    onMutationError: (error) => {
      notification.open?.({
        type: "error",
        message: extractApiErrorMessage(error),
      });
    },
  });
  return (
    <Edit saveButtonProps={saveButtonProps}>
      <HealthInsurerForm
        formProps={formProps}
        queryResult={queryResult}
        isEdit
      />
    </Edit>
  );
};
